module.exports = __webpack_public_path__ + "img/pastures_al.6e54394e.svg";